export default __webpack_public_path__ + "static/media/github.8da22b29.svg";